import { render, staticRenderFns } from "./SithMesInventoryReceiptReturnRecordEdit.vue?vue&type=template&id=65101d66&"
import script from "./SithMesInventoryReceiptReturnRecordEdit.vue?vue&type=script&lang=js&"
export * from "./SithMesInventoryReceiptReturnRecordEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports